export enum LegalEntityState {
  InVerification = 'IN_VERIFICATION',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  OnHold = 'ON_HOLD',
}
